import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import './PlanSalle.css';

const COLOR_SWATCHES = ['#4DFFD2', '#4f8aff', '#7c5cfc', '#f59e0b', '#ef4444', '#10b981', '#ec4899', '#06b6d4', '#6366f1'];
const ICONS = ['🎷', '🎸', '🎹', '🎤', '🎭', '🎶', '🥁', '🎺'];

const DEFAULT_TARIFS = [
  { id: 'vip',  lbl: 'VIP',         col: '#f5a623', ct: '#92400e', p: 45, pm: 32 },
  { id: 'part', lbl: 'Partenaire',  col: '#9b59b6', ct: '#4a0072', p: 35, pm: 25 },
  { id: 'std',  lbl: 'Standard',    col: '#4f8aff', ct: '#1e3a8a', p: 25, pm: 18 },
  { id: 'dbt',  lbl: 'Debout',      col: '#22d3a0', ct: '#065f46', p: 15, pm: 10 },
];

function ha(h, a) {
  const r = parseInt(h.slice(1, 3), 16);
  const g = parseInt(h.slice(3, 5), 16);
  const b = parseInt(h.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${a})`;
}
function hexLum(hex) {
  if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) return 0.5;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}
function brandText(hex) { return hexLum(hex) > 0.55 ? '#0a1a14' : '#ffffff'; }

const ELEM_DEFAULTS = {
  scene:  { w: 410, h: 54,  lbl: '🎭 SCÈNE',   tid: null,  s: 0 },
  tr:     { w: 76,  h: 76,  lbl: 'T1',         tid: 'std', s: 4 },
  tl:     { w: 136, h: 52,  lbl: 'T-Longue',   tid: 'std', s: 8 },
  rang:   { w: 218, h: 32,  lbl: 'Rang A',     tid: 'std', s: 10 },
  fosse:  { w: 196, h: 92,  lbl: '🕺 DEBOUT',  tid: 'dbt', s: 60 },
  vip:    { w: 178, h: 116, lbl: '⭐ VIP',     tid: 'vip', s: 12 },
  bar:    { w: 136, h: 46,  lbl: '🍺 Bar',     tid: null,  s: 0 },
  entree: { w: 126, h: 36,  lbl: '🚪 Entrée',  tid: null,  s: 0 },
  wc:     { w: 58,  h: 46,  lbl: '🚻',         tid: null,  s: 0 },
  lbl:    { w: 116, h: 26,  lbl: 'Zone A',     tid: null,  s: 0 },
};

const TEMPLATES = {
  cafe: () => {
    let id = 1;
    const n = () => 'e' + (id++);
    return [
      { id: n(), type: 'entree', x: 285, y: 452, w: 158, h: 36, lbl: '🚪 ENTRÉE', tid: null, s: 0 },
      { id: n(), type: 'scene',  x: 98,  y: 12,  w: 494, h: 54, lbl: '🎭 SCÈNE',  tid: null, s: 0 },
      { id: n(), type: 'fosse',  x: 196, y: 88,  w: 296, h: 78, lbl: '🕺 FOSSE',  tid: 'dbt', s: 60 },
      { id: n(), type: 'tr', x: 32,  y: 102, w: 76, h: 76, lbl: 'T1', tid: 'vip', s: 4 },
      { id: n(), type: 'tr', x: 32,  y: 198, w: 76, h: 76, lbl: 'T2', tid: 'vip', s: 4 },
      { id: n(), type: 'tr', x: 32,  y: 294, w: 76, h: 76, lbl: 'T3', tid: 'vip', s: 4 },
      { id: n(), type: 'tr', x: 572, y: 102, w: 76, h: 76, lbl: 'T4', tid: 'vip', s: 4 },
      { id: n(), type: 'tr', x: 572, y: 198, w: 76, h: 76, lbl: 'T5', tid: 'vip', s: 4 },
      { id: n(), type: 'tr', x: 572, y: 294, w: 76, h: 76, lbl: 'T6', tid: 'vip', s: 4 },
      { id: n(), type: 'rang', x: 78,  y: 298, w: 216, h: 32, lbl: 'Rang A', tid: 'std', s: 10 },
      { id: n(), type: 'rang', x: 78,  y: 340, w: 216, h: 32, lbl: 'Rang B', tid: 'std', s: 10 },
      { id: n(), type: 'rang', x: 356, y: 298, w: 216, h: 32, lbl: 'Rang C', tid: 'std', s: 10 },
      { id: n(), type: 'rang', x: 356, y: 340, w: 216, h: 32, lbl: 'Rang D', tid: 'std', s: 10 },
      { id: n(), type: 'bar', x: 548, y: 400, w: 128, h: 48, lbl: '🍺 BAR', tid: null, s: 0 },
      { id: n(), type: 'wc',  x: 14,  y: 412, w: 58,  h: 48, lbl: '🚻',     tid: null, s: 0 },
    ];
  },
  theatre: () => {
    let id = 1;
    const n = () => 'e' + (id++);
    const out = [
      { id: n(), type: 'scene',  x: 78, y: 12,  w: 534, h: 54, lbl: '🎭 SCÈNE',   tid: null, s: 0 },
      { id: n(), type: 'entree', x: 276, y: 462, w: 138, h: 36, lbl: '🚪 ENTRÉE', tid: null, s: 0 },
      { id: n(), type: 'wc',     x: 14, y: 90,  w: 54,  h: 46, lbl: '🚻',         tid: null, s: 0 },
    ];
    const tr = ['vip', 'vip', 'part', 'std', 'std', 'std', 'dbt'];
    ['A', 'B', 'C', 'D', 'E', 'F', 'G'].forEach((nm, i) => {
      out.push({ id: n(), type: 'rang', x: 78, y: 90 + i * 50, w: 534, h: 36, lbl: 'Rang ' + nm, tid: tr[i], s: i < 2 ? 12 : i < 5 ? 16 : 20 });
    });
    return out;
  },
  mixte: () => {
    let id = 1;
    const n = () => 'e' + (id++);
    return [
      { id: n(), type: 'scene', x: 138, y: 12,  w: 414, h: 54, lbl: '🎭 SCÈNE', tid: null, s: 0 },
      { id: n(), type: 'vip',   x: 138, y: 88,  w: 414, h: 86, lbl: '⭐ VIP',   tid: 'vip', s: 18 },
      { id: n(), type: 'tr',    x: 26,  y: 90,  w: 76,  h: 76, lbl: 'T1', tid: 'vip', s: 4 },
      { id: n(), type: 'tr',    x: 584, y: 90,  w: 76,  h: 76, lbl: 'T2', tid: 'vip', s: 4 },
      { id: n(), type: 'rang',  x: 78,  y: 204, w: 534, h: 34, lbl: 'Rang A', tid: 'part', s: 14 },
      { id: n(), type: 'rang',  x: 78,  y: 248, w: 534, h: 34, lbl: 'Rang B', tid: 'std',  s: 14 },
      { id: n(), type: 'rang',  x: 78,  y: 292, w: 534, h: 34, lbl: 'Rang C', tid: 'std',  s: 14 },
      { id: n(), type: 'fosse', x: 138, y: 346, w: 414, h: 68, lbl: '🕺 DEBOUT', tid: 'dbt', s: 80 },
      { id: n(), type: 'bar',   x: 556, y: 354, w: 118, h: 54, lbl: '🍺 BAR',   tid: null, s: 0 },
      { id: n(), type: 'entree',x: 254, y: 444, w: 182, h: 36, lbl: '🚪 ENTRÉE', tid: null, s: 0 },
      { id: n(), type: 'wc',    x: 14,  y: 412, w: 54,  h: 48, lbl: '🚻',       tid: null, s: 0 },
    ];
  },
};

export default function PlanSalle() {
  // Theme & event
  const [brand, setBrand] = useState('#4DFFD2');
  const [asso, setAsso] = useState('Le Caveau Blues');
  const [evt, setEvt] = useState('Jazz Night');
  const [info, setInfo] = useState('Vendredi 20 Juin · 20h30');
  const [icon, setIcon] = useState('🎷');
  const [tarifs, setTarifs] = useState(DEFAULT_TARIFS);
  // Views & method
  const [view, setView] = useState('method'); // method | drag | grid | img | client
  const [tab, setTab] = useState('config');   // config | client
  // Drag & drop
  const [elems, setElems] = useState([]);
  const [selId, setSelId] = useState(null);
  // Grid
  const [gridSel, setGridSel] = useState({});
  const [gridMode, setGridMode] = useState('std');
  // Image
  const [imgSrc, setImgSrc] = useState(null);
  const [pins, setPins] = useState([]);
  const [pinMode, setPinMode] = useState('standard');
  // Client cart
  const [panier, setPanier] = useState([]);
  const [sold, setSold] = useState({});
  const [selectedTarif, setSelectedTarif] = useState('vip');
  // Modals
  const [payOpen, setPayOpen] = useState(false);
  const [okOpen, setOkOpen] = useState(false);
  const [payName, setPayName] = useState('');
  const [payEmail, setPayEmail] = useState('');
  const [payLoading, setPayLoading] = useState(false);
  const [okMsg, setOkMsg] = useState('');

  // Refs
  const canvasRef = useRef(null);
  const dragRef = useRef({ id: null, dox: 0, doy: 0 });
  const idRef = useRef(100);
  const nextId = () => 'e' + (idRef.current++);

  const bRGB = (() => {
    const r = parseInt(brand.slice(1, 3), 16);
    const g = parseInt(brand.slice(3, 5), 16);
    const b = parseInt(brand.slice(5, 7), 16);
    return `${r},${g},${b}`;
  })();
  const bTxt = brandText(brand);

  // Apply brand CSS variables to scoped root
  const rootStyle = {
    '--brand': brand,
    '--brand-rgb': bRGB,
    '--brand-text': bTxt,
  };

  // Mouse handlers for drag
  useEffect(() => {
    const onMove = (e) => {
      if (!dragRef.current.id) return;
      const cv = canvasRef.current;
      if (!cv) return;
      const r = cv.getBoundingClientRect();
      setElems((arr) => arr.map((em) => {
        if (em.id !== dragRef.current.id) return em;
        const nx = Math.max(0, Math.min(e.clientX - r.left - dragRef.current.dox, cv.offsetWidth - em.w));
        const ny = Math.max(0, Math.min(e.clientY - r.top - dragRef.current.doy, cv.offsetHeight - em.h));
        return { ...em, x: nx, y: ny };
      }));
    };
    const onUp = () => { dragRef.current.id = null; };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
  }, []);

  const selectMethod = (m) => {
    setView(m);
    if (m === 'drag' && elems.length === 0) {
      const tpl = TEMPLATES.cafe();
      setElems(tpl);
      idRef.current = 200;
    }
  };

  const addEl = (type) => {
    const df = ELEM_DEFAULTS[type] || { w: 100, h: 58, lbl: 'Élément', tid: null, s: 0 };
    const newEl = {
      id: nextId(),
      type,
      x: 42 + Math.random() * 170,
      y: 58 + Math.random() * 170,
      w: df.w, h: df.h, lbl: df.lbl, tid: df.tid, s: df.s,
    };
    setElems((arr) => [...arr, newEl]);
    setSelId(newEl.id);
  };

  const startDrag = (e, id) => {
    if (e.target.classList.contains('delbtn')) return;
    e.preventDefault();
    setSelId(id);
    const target = e.currentTarget;
    const cv = canvasRef.current;
    const cr = cv.getBoundingClientRect();
    const er = target.getBoundingClientRect();
    dragRef.current = { id, dox: e.clientX - er.left, doy: e.clientY - er.top };
  };

  const updateElem = (id, patch) => setElems((arr) => arr.map((em) => em.id === id ? { ...em, ...patch } : em));
  const deleteElem = (id) => { setElems((arr) => arr.filter((em) => em.id !== id)); if (selId === id) setSelId(null); };
  const clearCanvas = () => { if (window.confirm('Vider la salle ?')) { setElems([]); setSelId(null); } };
  const loadTemplate = (t) => { setElems(TEMPLATES[t]()); idRef.current = 300; toast.success('📐 Modèle chargé — adaptez-le à votre salle !'); };

  const selectedElem = elems.find((e) => e.id === selId);
  const noSeats = ['scene', 'bar', 'entree', 'wc', 'lbl'];

  // Grid handlers
  const toggleGridCell = (key) => {
    setGridSel((g) => {
      const c = g[key] || 'off';
      let next;
      if (gridMode === 'era') next = 'off';
      else if (gridMode === 'vip') next = c === 'vip' ? 'off' : 'vip';
      else next = c === 'off' ? 'on' : 'off';
      return { ...g, [key]: next };
    });
  };

  // Image handlers
  const handleImgUpload = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    const rd = new FileReader();
    rd.onload = (ev) => setImgSrc(ev.target.result);
    rd.readAsDataURL(f);
  };
  const addPin = (e) => {
    if (!imgSrc) return;
    if (pinMode === 'era') return;
    const ic = e.currentTarget;
    const r = ic.getBoundingClientRect();
    const px = ((e.clientX - r.left) / r.width * 100).toFixed(2);
    const py = ((e.clientY - r.top) / r.height * 100).toFixed(2);
    const t = tarifs.find((x) => x.id === pinMode) || tarifs[2];
    setPins((arr) => [...arr, { id: 'p' + (idRef.current++), x: px, y: py, tid: t.id, lbl: t.lbl, col: t.col, ct: t.ct, idx: arr.length + 1 }]);
  };
  const removePin = (id) => {
    setPins((arr) => arr.filter((p) => p.id !== id).map((p, i) => ({ ...p, idx: i + 1 })));
  };

  // Client cart
  const togSeat = (eId, si, lbl, tid) => {
    const key = `${eId}_${si}`;
    setPanier((arr) => {
      const ex = arr.findIndex((p) => p.key === key);
      if (ex >= 0) return arr.filter((_, i) => i !== ex);
      return [...arr, { key, eId, si, lbl, tid }];
    });
  };
  const togZone = (eId, lbl, tid) => {
    setPanier((arr) => {
      const ex = arr.findIndex((p) => p.eId === eId && p.si === -1);
      if (ex >= 0) return arr.filter((_, i) => i !== ex);
      return [...arr, { key: eId + '_z', eId, si: -1, lbl, tid }];
    });
  };
  const togTbl = (eId, lbl, tid, max) => {
    const sn = Object.keys(sold).filter((k) => k.startsWith(eId + '_')).length;
    const inC = panier.filter((p) => p.eId === eId).length;
    const ex = panier.findIndex((p) => p.eId === eId);
    if (ex >= 0) setPanier((arr) => arr.filter((_, i) => i !== ex));
    else if (sn + inC < max) setPanier((arr) => [...arr, { key: `${eId}_${inC}`, eId, si: inC, lbl: `${lbl} — Place ${inC + 1}`, tid }]);
  };

  const total = panier.reduce((a, i) => { const t = tarifs.find((x) => x.id === i.tid); return a + (t ? t.p : 0); }, 0);

  const openPay = () => { if (panier.length) setPayOpen(true); };
  const doPay = () => {
    if (!payName || !payEmail) { toast.warning('⚠️ Renseignez votre nom et email'); return; }
    setPayLoading(true);
    setTimeout(() => {
      setPayLoading(false);
      const newSold = { ...sold };
      panier.forEach((p) => { newSold[p.key] = true; });
      setSold(newSold);
      setPanier([]);
      setPayOpen(false);
      setOkMsg(`Billet envoyé à ${payEmail}. Bonne soirée !`);
      setOkOpen(true);
      setPayName(''); setPayEmail('');
    }, 1500);
  };

  const savePreview = () => { setView('client'); setTab('client'); toast.success('✅ Plan publié ! Aperçu client actif.'); };
  const goConfig = () => { setView('method'); setTab('config'); };
  const goClient = () => { setView('client'); setTab('client'); };

  // Available seats counter (for header badge)
  const availCount = (() => {
    if (view !== 'client' && tab !== 'client') return 0;
    let avail = 0;
    if (imgSrc && pins.length) {
      pins.forEach((p) => { if (!sold['img_' + p.id]) avail++; });
    } else if (Object.keys(gridSel).length) {
      Object.entries(gridSel).forEach(([k, st]) => { if (st !== 'off' && !sold['g_' + k]) avail++; });
    } else {
      elems.forEach((em) => {
        if (em.type === 'rang') { for (let i = 0; i < em.s; i++) { if (!sold[`${em.id}_${i}`]) avail++; } }
        else if (em.type === 'fosse' || em.type === 'vip' || em.type === 'tr' || em.type === 'tl') {
          const sn = Object.keys(sold).filter((k) => k.startsWith(em.id + '_')).length;
          avail += Math.max(0, em.s - sn);
        }
      });
    }
    return avail;
  })();

  return (
    <div className="plansalle" style={rootStyle} data-testid="plansalle-root">
      {/* NAV */}
      <div className="nav">
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <div className="nav-logo">A</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 800 }}>{asso}</div>
            <div style={{ fontSize: 11, color: 'var(--muted)' }}>{view === 'method' ? 'Configurez votre salle →' : evt}</div>
          </div>
        </div>
        <div className="nav-tabs">
          <button className={`ntab ${tab === 'config' ? 'on' : ''}`} onClick={goConfig} data-testid="tab-config">⚙️ Configurer la salle</button>
          <button className={`ntab ${tab === 'client' ? 'on' : ''}`} onClick={goClient} data-testid="tab-client">🎫 Billetterie publique</button>
        </div>
        <div style={{ display: 'flex', gap: 9, alignItems: 'center' }}>
          <div className="live" />
          <div className="nbadge">{availCount} places</div>
          <button className="btn btn-brand btn-sm" onClick={savePreview} data-testid="publish-btn">💾 Publier</button>
        </div>
      </div>

      {/* CHOIX MÉTHODE */}
      <div className={`view ${view === 'method' ? 'on' : ''} v-method-wrap`}>
        <div className="mc">
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 7 }}>AssoPerf · Plan de salle</div>
          <div style={{ fontSize: 26, fontWeight: 900, marginBottom: 7 }}>Comment créer votre plan ?</div>
          <div style={{ fontSize: 14, color: 'var(--muted)' }}>Choisissez la méthode la plus adaptée à votre salle.</div>
          <div className="mc-cards">
            <div className="mcard" onClick={() => selectMethod('drag')} data-testid="method-drag">
              <div className="mcard-ico">🖱️</div>
              <div className="mcard-name">Drag &amp; Drop</div>
              <div className="mcard-desc">Placez librement tables, rangs, zones VIP, fosse, bar, entrée. Glissez pour positionner exactement comme votre vraie salle.</div>
              <div className="mtag" style={{ background: 'rgba(var(--brand-rgb),.1)', color: 'var(--brand-text)' }}>✨ Recommandé</div>
            </div>
            <div className="mcard" onClick={() => selectMethod('grid')} data-testid="method-grid">
              <div className="mcard-ico">🔲</div>
              <div className="mcard-name">Grille simple</div>
              <div className="mcard-desc">Cliquez sur les cases pour activer les sièges. Rangs, VIP et fosse configurés en quelques secondes.</div>
              <div className="mtag" style={{ background: '#f0fdf4', color: '#166534' }}>⚡ Plus rapide</div>
            </div>
            <div className="mcard" onClick={() => selectMethod('img')} data-testid="method-img">
              <div className="mcard-ico">🖼️</div>
              <div className="mcard-name">Photo du plan</div>
              <div className="mcard-desc">Importez une photo de votre vraie salle, puis placez des épingles sur chaque table ou siège.</div>
              <div className="mtag" style={{ background: '#fef3c7', color: '#92400e' }}>🎯 Fidèle à la réalité</div>
            </div>
          </div>
        </div>
      </div>

      {/* DRAG & DROP */}
      <div className={`view ${view === 'drag' ? 'on' : ''}`}>
        <div className="el">
          <div className="epanel">
            <div className="escroll">
              <ConfigSection
                asso={asso} setAsso={setAsso}
                brand={brand} setBrand={setBrand}
                evt={evt} setEvt={setEvt} info={info} setInfo={setInfo}
                icon={icon} setIcon={setIcon}
                showIcons showInfo
              />
              <TarifsSection tarifs={tarifs} setTarifs={setTarifs} idRef={idRef} />
              <div className="esec">
                <div className="esec-t">Ajouter à la salle</div>
                <div className="tgrid">
                  {[
                    ['scene', '🎭', 'Scène'], ['tr', '⭕', 'Table ronde'],
                    ['tl', '▭', 'Table longue'], ['rang', '💺', 'Rang sièges'],
                    ['fosse', '🕺', 'Zone debout'], ['vip', '⭐', 'Zone VIP'],
                    ['bar', '🍺', 'Bar'], ['entree', '🚪', 'Entrée'],
                    ['wc', '🚻', 'WC'], ['lbl', '🏷️', 'Étiquette'],
                  ].map(([k, i, l]) => (
                    <button key={k} className="tool" onClick={() => addEl(k)}><span className="tool-i">{i}</span>{l}</button>
                  ))}
                </div>
              </div>
              {selectedElem && (
                <div className="esec">
                  <div className="ecfg">
                    <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em', color: 'var(--muted2)', marginBottom: 9 }}>✏️ {selectedElem.type}</div>
                    <div className="crow">
                      <label className="clbl">Étiquette</label>
                      <input className="cinp" value={selectedElem.lbl} onChange={(e) => updateElem(selId, { lbl: e.target.value })} />
                    </div>
                    {!noSeats.includes(selectedElem.type) && (
                      <>
                        <div className="crow">
                          <label className="clbl">Catégorie</label>
                          <select className="cinp" value={selectedElem.tid || ''} onChange={(e) => updateElem(selId, { tid: e.target.value })}>
                            {tarifs.map((t) => <option key={t.id} value={t.id}>{t.lbl} — {t.p}€</option>)}
                          </select>
                        </div>
                        <div className="crow">
                          <label className="clbl">Nb de places</label>
                          <input className="cinp" type="number" min="1" max="100" value={selectedElem.s}
                            onChange={(e) => updateElem(selId, { s: parseInt(e.target.value) || 1 })} />
                        </div>
                      </>
                    )}
                    <button className="btn btn-danger btn-sm btn-full" onClick={() => deleteElem(selId)}>🗑 Supprimer</button>
                  </div>
                </div>
              )}
            </div>
            <div className="efooter">
              <div style={{ display: 'flex', gap: 5 }}>
                <button className="btn btn-ghost btn-sm" style={{ flex: 1 }} onClick={clearCanvas}>🗑</button>
                <button className="btn btn-ghost btn-sm" style={{ flex: 2 }} onClick={() => loadTemplate('cafe')}>📐 Café-concert</button>
              </div>
              <div style={{ display: 'flex', gap: 5 }}>
                <button className="btn btn-ghost btn-sm" style={{ flex: 1 }} onClick={() => loadTemplate('theatre')}>📐 Théâtre</button>
                <button className="btn btn-ghost btn-sm" style={{ flex: 1 }} onClick={() => loadTemplate('mixte')}>📐 Mixte</button>
              </div>
              <button className="btn btn-brand btn-sm btn-full" onClick={savePreview}>💾 Sauvegarder &amp; Prévisualiser</button>
            </div>
          </div>
          <div className="ecanvas-area">
            <div className="ecanvas" ref={canvasRef} onClick={(e) => { if (e.target === canvasRef.current) setSelId(null); }}>
              {elems.map((em) => (
                <DragElement
                  key={em.id} em={em} selected={em.id === selId}
                  tarifs={tarifs} brand={brand} bTxt={bTxt}
                  onMouseDown={(e) => startDrag(e, em.id)}
                  onClick={(e) => { e.stopPropagation(); setSelId(em.id); }}
                  onDelete={(e) => { e.stopPropagation(); deleteElem(em.id); }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* GRILLE */}
      <div className={`view ${view === 'grid' ? 'on' : ''}`}>
        <div className="gl">
          <div className="gpanel">
            <ConfigSection
              asso={asso} setAsso={setAsso}
              brand={brand} setBrand={setBrand}
              evt={evt} setEvt={setEvt} info={info} setInfo={setInfo}
              showInfo
            />
            <div style={{ marginTop: 14 }}>
              <div className="esec-t" style={{ marginBottom: 8 }}>Mode de sélection</div>
              <div className="gmode-btns">
                <button className={`gmbtn ${gridMode === 'std' ? 'on' : ''}`} onClick={() => setGridMode('std')}>🎫 Standard</button>
                <button className={`gmbtn ${gridMode === 'vip' ? 'on' : ''}`} onClick={() => setGridMode('vip')}>⭐ VIP</button>
                <button className={`gmbtn ${gridMode === 'era' ? 'on' : ''}`} onClick={() => setGridMode('era')}>🗑 Effacer</button>
              </div>
            </div>
            <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 5 }}>
              <button className="btn btn-brand btn-sm btn-full" onClick={savePreview}>💾 Sauvegarder &amp; Prévisualiser</button>
              <button className="btn btn-ghost btn-sm btn-full" onClick={() => { if (window.confirm('Réinitialiser ?')) setGridSel({}); }}>🗑 Réinitialiser</button>
            </div>
          </div>
          <div className="gcanvas-area">
            <div className="gcanvas">
              <div className="g-scene">🎭 Scène</div>
              <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted2)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 7 }}>Tables — cliquez pour activer</div>
              <div className="g-twrap">
                {[...Array(10)].map((_, i) => {
                  const k = `t${i + 1}`;
                  const st = gridSel[k] || 'off';
                  const cls = st === 'vip' ? 'gvip' : st === 'on' ? 'on' : '';
                  return (
                    <div key={k} className={`gtbl ${cls}`} onClick={() => toggleGridCell(k)}>
                      <span style={{ fontSize: 12, fontWeight: 800 }}>T{i + 1}</span>
                      <span style={{ fontSize: 9 }}>4p</span>
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted2)', textTransform: 'uppercase', letterSpacing: '.06em', margin: '10px 0 6px' }}>Rangs de sièges</div>
              {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].map((rang) => (
                <div className="grow-w" key={rang}>
                  <div className="grow-l">Rang {rang}</div>
                  <div className="grow-s">
                    {[...Array(16)].map((_, i) => {
                      const k = `r_${rang}_${i + 1}`;
                      const st = gridSel[k] || 'off';
                      const cls = st === 'vip' ? 'gvip' : st === 'on' ? 'on' : '';
                      return <div key={k} className={`gs ${cls}`} onClick={() => toggleGridCell(k)}>{i + 1}</div>;
                    })}
                  </div>
                </div>
              ))}
              <div className={`g-fosse ${gridSel.fosse === 'on' ? 'on' : ''}`} onClick={() => setGridSel((g) => ({ ...g, fosse: g.fosse === 'on' ? 'off' : 'on' }))}>
                <div style={{ fontSize: 13, fontWeight: 800, color: gridSel.fosse === 'on' ? bTxt : 'var(--muted)' }}>🕺 Zone debout / Fosse</div>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>Cliquez pour activer · 80 places</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* IMAGE */}
      <div className={`view ${view === 'img' ? 'on' : ''}`}>
        <div className="il">
          <div className="ipanel">
            <ConfigSection
              asso={asso} setAsso={setAsso}
              brand={brand} setBrand={setBrand}
              evt={evt} setEvt={setEvt} info={info} setInfo={setInfo}
            />
            <div style={{ marginTop: 14 }}>
              <div className="esec-t" style={{ marginBottom: 8 }}>Type d'épingle</div>
              <div className="gmode-btns">
                <button className={`gmbtn ${pinMode === 'standard' ? 'on' : ''}`} onClick={() => setPinMode('standard')}>💺 Standard</button>
                <button className={`gmbtn ${pinMode === 'vip' ? 'on' : ''}`} onClick={() => setPinMode('vip')}>⭐ VIP</button>
                <button className={`gmbtn ${pinMode === 'part' ? 'on' : ''}`} onClick={() => setPinMode('part')}>⭕ Partenaire</button>
                <button className={`gmbtn ${pinMode === 'era' ? 'on' : ''}`} onClick={() => setPinMode('era')}>🗑 Effacer</button>
              </div>
            </div>
            <div style={{ marginTop: 12, fontSize: 12, color: 'var(--muted)', lineHeight: 1.65, padding: 9, background: 'var(--bg)', borderRadius: 7 }}>
              💡 Importez votre plan de salle, puis cliquez sur chaque table ou place pour placer une épingle cliquable.
            </div>
            <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 5 }}>
              <button className="btn btn-brand btn-sm btn-full" onClick={savePreview}>💾 Sauvegarder &amp; Prévisualiser</button>
              <button className="btn btn-ghost btn-sm btn-full" onClick={() => setPins([])}>🗑 Effacer les épingles</button>
            </div>
          </div>
          <div className="icanvas-area">
            <div>
              {!imgSrc ? (
                <div className="iupload" onClick={() => document.getElementById('plansalle-file').click()}>
                  <div style={{ fontSize: 44 }}>🖼️</div>
                  <div style={{ fontSize: 15, fontWeight: 800 }}>Importer votre plan de salle</div>
                  <div style={{ fontSize: 13, color: 'var(--muted)' }}>PNG · JPG · Photo de votre vraie salle</div>
                  <button className="btn btn-brand">📁 Choisir un fichier</button>
                  <input id="plansalle-file" type="file" accept="image/*" style={{ display: 'none' }} onChange={handleImgUpload} />
                </div>
              ) : (
                <div className="icanvas" onClick={addPin}>
                  <img src={imgSrc} alt="Plan" />
                  {pins.map((p) => (
                    <div key={p.id} className="pin" style={{ left: `${p.x}%`, top: `${p.y}%` }}
                      onClick={(e) => { e.stopPropagation(); if (pinMode === 'era') removePin(p.id); }}>
                      <div className="pin-dot" style={{ background: p.col, color: p.ct || '#fff' }}>{p.idx}</div>
                      <div className="pin-lbl" style={{ color: p.col }}>{p.lbl}</div>
                    </div>
                  ))}
                </div>
              )}
              <div style={{ marginTop: 9, fontSize: 12, color: 'var(--muted)', textAlign: 'center' }}>{pins.length} épingle(s)</div>
            </div>
          </div>
        </div>
      </div>

      {/* CLIENT */}
      <div className={`view ${view === 'client' ? 'on' : ''}`}>
        <div className="cl">
          <div className="cmain">
            <div className="ecard" style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 16 }}>
              <div style={{ fontSize: 36 }}>{icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 17, fontWeight: 800 }}>{evt}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{info}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)' }}>{asso}</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 26, fontWeight: 900, color: 'var(--brand-text)' }}>{availCount}</div>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>places dispo</div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 12, fontSize: 12, color: 'var(--muted)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 13, height: 13, borderRadius: 3, background: 'rgba(var(--brand-rgb),.13)', border: '1.5px solid rgba(var(--brand-rgb),.55)' }} />Disponible</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 13, height: 13, borderRadius: 3, background: 'var(--brand)' }} />Sélectionné</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 13, height: 13, borderRadius: 3, background: 'var(--sold)', border: '1.5px solid var(--sold-b)', opacity: .6 }} />Réservé</div>
            </div>
            <ClientPlan
              elems={elems} gridSel={gridSel} pins={pins} imgSrc={imgSrc}
              tarifs={tarifs} brand={brand} bTxt={bTxt}
              panier={panier} sold={sold}
              togSeat={togSeat} togZone={togZone} togTbl={togTbl}
            />
          </div>
          <div className="cside">
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.07em', color: 'var(--muted2)', marginBottom: 9 }}>Tarifs</div>
              {tarifs.map((t) => (
                <div key={t.id} className={`topt ${selectedTarif === t.id ? 'on' : ''}`} onClick={() => setSelectedTarif(t.id)}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: t.col }}>{t.lbl}</div>
                    <div style={{ fontSize: 10, color: 'var(--muted)' }}>Membres : {t.pm}€</div>
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 900, color: t.col }}>{t.p}€</div>
                </div>
              ))}
              <div style={{ marginTop: 7, padding: '8px 10px', background: 'rgba(var(--brand-rgb),.07)', border: '1.5px solid rgba(var(--brand-rgb),.2)', borderRadius: 7, fontSize: 11, fontWeight: 600, color: 'var(--brand-text)' }}>
                🎁 Membres : -30% sur tous les tarifs
              </div>
            </div>
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.07em', color: 'var(--muted2)', marginBottom: 9 }}>Votre sélection</div>
              <div className="pbox">
                {panier.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: 18, color: 'var(--muted)', fontSize: 13 }}>
                    <div style={{ fontSize: 22, marginBottom: 7 }}>👆</div>Cliquez sur une place
                  </div>
                ) : (
                  <>
                    {panier.map((item) => {
                      const t = tarifs.find((x) => x.id === item.tid);
                      const p = t ? t.p : 0;
                      return (
                        <div key={item.key} className="prow">
                          <span style={{ color: 'var(--muted)', fontSize: 12 }}>{item.lbl}</span>
                          <strong style={{ color: 'var(--brand-text)' }}>{p}€</strong>
                        </div>
                      );
                    })}
                    <div className="ptotal"><span>Total</span><span style={{ color: 'var(--brand-text)' }}>{total}€</span></div>
                    <button className="btn btn-brand btn-full" style={{ marginTop: 11 }} onClick={openPay} data-testid="reserve-btn">🔒 Réserver →</button>
                  </>
                )}
              </div>
            </div>
            <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.8, padding: 11, background: 'var(--bg)', borderRadius: 9, border: '1px solid var(--border)' }}>
              ✅ Paiement sécurisé Stripe<br />📧 Billet QR code par email<br />🔄 Remboursable 48h avant
            </div>
          </div>
        </div>
      </div>

      {/* MODAL PAY */}
      <div className={`mbg ${payOpen ? 'on' : ''}`} onClick={(e) => { if (e.target.classList.contains('mbg')) setPayOpen(false); }}>
        <div className="modal">
          <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 3 }}>Confirmer la réservation</div>
          <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16 }}>{panier.map((p) => p.lbl).join(' + ')}</div>
          <div className="fg"><label className="fl">Prénom &amp; Nom</label><input className="fi" placeholder="Marie Dupont" value={payName} onChange={(e) => setPayName(e.target.value)} /></div>
          <div className="fg"><label className="fl">Email</label><input className="fi" type="email" placeholder="marie@email.fr" value={payEmail} onChange={(e) => setPayEmail(e.target.value)} /></div>
          <div style={{ background: 'rgba(var(--brand-rgb),.07)', border: '1.5px solid rgba(var(--brand-rgb),.22)', borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 12, color: 'var(--muted)' }}>
            🎫 Billet QR code envoyé par email immédiatement.
          </div>
          <div style={{ display: 'flex', gap: 7 }}>
            <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setPayOpen(false)}>Annuler</button>
            <button className="btn btn-brand" style={{ flex: 2 }} onClick={doPay} disabled={payLoading}>{payLoading ? '⏳ Stripe...' : `🔒 Payer ${total}€`}</button>
          </div>
          <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted2)', marginTop: 9 }}>Paiement sécurisé Stripe</div>
        </div>
      </div>

      {/* MODAL OK */}
      <div className={`mbg ${okOpen ? 'on' : ''}`} onClick={(e) => { if (e.target.classList.contains('mbg')) setOkOpen(false); }}>
        <div className="modal" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 50, marginBottom: 10 }}>🎫</div>
          <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 8 }}>Réservation confirmée !</div>
          <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 18 }}>{okMsg}</div>
          <button className="btn btn-brand btn-full" onClick={() => setOkOpen(false)}>Parfait →</button>
        </div>
      </div>
    </div>
  );
}

/* ─── Sub-components ─── */

function ConfigSection({ asso, setAsso, brand, setBrand, evt, setEvt, info, setInfo, icon, setIcon, showIcons, showInfo }) {
  return (
    <div className="esec">
      <div className="esec-t">Mon association</div>
      <div className="crow">
        <label className="clbl">Nom affiché</label>
        <input className="cinp" value={asso} onChange={(e) => setAsso(e.target.value)} />
      </div>
      <div className="crow">
        <label className="clbl">Couleur principale</label>
        <div className="crow-color">
          <input type="color" className="cpick" value={brand} onChange={(e) => setBrand(e.target.value)} />
          <input className="cinp" style={{ fontFamily: 'monospace', fontSize: 11 }} value={brand} onChange={(e) => /^#[0-9A-Fa-f]{0,6}$/.test(e.target.value) && setBrand(e.target.value)} />
        </div>
        <div className="sws">
          {COLOR_SWATCHES.map((c) => (
            <div key={c} className={`sw ${brand.toUpperCase() === c.toUpperCase() ? 'on' : ''}`} style={{ background: c }} onClick={() => setBrand(c)} />
          ))}
        </div>
      </div>
      {showIcons && (
        <div className="crow">
          <label className="clbl">Icône événement</label>
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            {ICONS.map((i) => (
              <span key={i} className="icoframe" style={{ borderColor: icon === i ? 'var(--brand)' : undefined, background: icon === i ? 'rgba(var(--brand-rgb),.08)' : undefined }} onClick={() => setIcon(i)}>{i}</span>
            ))}
          </div>
        </div>
      )}
      <div className="crow">
        <label className="clbl">Nom événement</label>
        <input className="cinp" value={evt} onChange={(e) => setEvt(e.target.value)} />
      </div>
      {showInfo && (
        <div className="crow">
          <label className="clbl">Date &amp; lieu</label>
          <input className="cinp" value={info} onChange={(e) => setInfo(e.target.value)} />
        </div>
      )}
    </div>
  );
}

function TarifsSection({ tarifs, setTarifs, idRef }) {
  const update = (id, patch) => setTarifs((arr) => arr.map((t) => t.id === id ? { ...t, ...patch } : t));
  const addTarif = () => setTarifs((arr) => [...arr, { id: 't' + (idRef.current++), lbl: 'Nouveau', col: '#888', ct: '#333', p: 20, pm: 14 }]);
  return (
    <div className="esec">
      <div className="esec-t">Tarifs &amp; catégories</div>
      <div>
        {tarifs.map((t) => (
          <div className="trow" key={t.id}>
            <div className="tdot" style={{ background: t.col }} />
            <input className="tni" value={t.lbl} onChange={(e) => update(t.id, { lbl: e.target.value })} />
            <input className="tpi" type="number" value={t.p} onChange={(e) => update(t.id, { p: +e.target.value })} />
            <span style={{ fontSize: 11, color: 'var(--muted)' }}>€</span>
          </div>
        ))}
      </div>
      <button className="btn btn-ghost btn-sm btn-full" onClick={addTarif} style={{ marginTop: 3 }}>＋ Ajouter un tarif</button>
    </div>
  );
}

function DragElement({ em, selected, tarifs, brand, bTxt, onMouseDown, onClick, onDelete }) {
  const t = tarifs.find((x) => x.id === em.tid);
  const c = t ? t.col : brand;
  const ct = t ? t.ct : bTxt;

  let style = { left: em.x, top: em.y, width: em.w, height: em.h };
  let content;

  if (em.type === 'scene') {
    style = { ...style, background: ha(brand, .07), border: `2px solid ${ha(brand, .42)}`, color: bTxt, borderRadius: '36px 36px 5px 5px', fontSize: 12, fontWeight: 800, letterSpacing: '.07em', textTransform: 'uppercase' };
    content = em.lbl;
  } else if (em.type === 'tr') {
    style = { ...style, background: ha(c, .11), border: `2px solid ${ha(c, .48)}`, color: ct, borderRadius: '50%', flexDirection: 'column', gap: 1 };
    content = (<><span style={{ fontSize: 11, fontWeight: 800 }}>{em.lbl}</span><span style={{ fontSize: 8, opacity: .7 }}>{em.s}p</span></>);
  } else if (em.type === 'tl') {
    style = { ...style, background: ha(c, .09), border: `2px solid ${ha(c, .38)}`, color: ct, borderRadius: 8, flexDirection: 'column' };
    content = <span style={{ fontSize: 11, fontWeight: 700 }}>{em.lbl} ({em.s}p)</span>;
  } else if (em.type === 'rang') {
    style = { ...style, background: ha(c, .05), border: `1.5px solid ${ha(c, .26)}`, padding: '3px 6px', borderRadius: 7, gap: 3, flexWrap: 'nowrap', overflow: 'hidden', justifyContent: 'flex-start' };
    content = (
      <>
        <span style={{ fontSize: 9, fontWeight: 700, color: ct, marginRight: 2, flexShrink: 0 }}>{em.lbl}</span>
        {[...Array(Math.min(em.s, 14))].map((_, i) => (
          <div className="ms" key={i} style={{ background: ha(c, .13), borderColor: ha(c, .48), color: ct }}>{i + 1}</div>
        ))}
      </>
    );
  } else if (em.type === 'fosse') {
    style = { ...style, background: ha(c, .06), border: `2px dashed ${ha(c, .38)}`, color: ct, borderRadius: 10, flexDirection: 'column', gap: 2, textAlign: 'center' };
    content = (<><div style={{ fontSize: 12, fontWeight: 800 }}>{em.lbl}</div><div style={{ fontSize: 10, opacity: .7 }}>{em.s}p</div></>);
  } else if (em.type === 'vip') {
    style = { ...style, background: ha(c, .07), border: `2px dashed ${ha(c, .38)}`, color: ct, borderRadius: 10, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', padding: 7, fontSize: 11, fontWeight: 700 };
    content = (<>{em.lbl}<br /><span style={{ fontSize: 9, opacity: .7 }}>{em.s}p</span></>);
  } else if (em.type === 'bar') {
    style = { ...style, background: 'var(--surface2)', border: '1.5px solid var(--border)', color: 'var(--muted)', borderRadius: 8, fontSize: 11, fontWeight: 600 };
    content = em.lbl;
  } else if (em.type === 'entree') {
    style = { ...style, background: ha(brand, .07), borderTop: `3px solid ${brand}`, color: bTxt, borderRadius: 7, fontSize: 12, fontWeight: 800 };
    content = em.lbl;
  } else if (em.type === 'wc') {
    style = { ...style, background: 'var(--surface2)', border: '1.5px solid var(--border)', color: 'var(--muted)', borderRadius: 7 };
    content = em.lbl;
  } else {
    style = { ...style, background: 'transparent', border: 'none', color: 'var(--muted)', fontSize: 12, fontWeight: 700 };
    content = em.lbl;
  }

  return (
    <div className={`ce ${selected ? 'sel' : ''}`} style={style} onMouseDown={onMouseDown} onClick={onClick}>
      {content}
      <button className="delbtn" onClick={onDelete}>✕</button>
    </div>
  );
}

function ClientPlan({ elems, gridSel, pins, imgSrc, tarifs, brand, bTxt, panier, sold, togSeat, togZone, togTbl }) {
  // Image-based plan
  if (imgSrc && pins.length) {
    return (
      <div className="cplan">
        <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>Cliquez sur une épingle pour sélectionner une place :</div>
        <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap' }}>
          {pins.map((p) => {
            const tar = tarifs.find((t) => t.id === p.tid) || tarifs[2];
            const key = 'img_' + p.id;
            const isSold = sold[key];
            const inC = panier.some((x) => x.key === key);
            return (
              <div key={p.id} className="cp-tbl" style={{
                width: 44, height: 44, borderRadius: '50%', border: `2px solid ${ha(tar.col, isSold ? .18 : .55)}`,
                background: isSold ? 'var(--sold)' : inC ? tar.col : ha(tar.col, .1),
                color: isSold ? 'var(--muted2)' : tar.ct,
                pointerEvents: isSold ? 'none' : 'auto',
              }} onClick={() => !isSold && togSeat('img_' + p.id, 0, `Place ${p.idx} — ${p.lbl}`, tar.id)}>
                <span style={{ fontSize: 11, fontWeight: 800 }}>{p.idx}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // Grid-based plan
  const hasGrid = Object.values(gridSel).some((v) => v && v !== 'off');
  if (hasGrid) {
    return (
      <div className="cplan">
        <div className="g-scene">🎭 Scène</div>
        <div className="g-twrap">
          {[...Array(10)].map((_, i) => {
            const k = `t${i + 1}`;
            const st = gridSel[k];
            if (!st || st === 'off') return null;
            const sk = 'g_' + k;
            const isSold = sold[sk];
            const inC = panier.some((p) => p.key === sk);
            const tar = st === 'vip' ? tarifs[0] : tarifs[2];
            return (
              <div key={k} className="cp-tbl" style={{
                width: 56, height: 56, borderRadius: '50%',
                border: `2px solid ${ha(tar.col, isSold ? .18 : .52)}`,
                background: isSold ? 'var(--sold)' : inC ? tar.col : ha(tar.col, .1),
                color: isSold ? 'var(--muted2)' : tar.ct,
                pointerEvents: isSold ? 'none' : 'auto',
              }} onClick={() => !isSold && togSeat(sk, 0, `Table ${i + 1}`, tar.id)}>
                <span style={{ fontSize: 12, fontWeight: 800 }}>T{i + 1}</span>
                <span style={{ fontSize: 9 }}>4p</span>
              </div>
            );
          })}
        </div>
        {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].map((rang) => {
          const seats = [];
          for (let i = 1; i <= 16; i++) {
            const k = `r_${rang}_${i}`;
            const st = gridSel[k];
            if (!st || st === 'off') continue;
            const sk = 'g_' + k;
            const isSold = sold[sk];
            const inC = panier.some((p) => p.key === sk);
            const tar = st === 'vip' ? tarifs[0] : tarifs[2];
            seats.push(
              <div key={k} className={`cp-seat ${isSold ? 'sold' : ''}`} style={{
                background: isSold ? '' : inC ? tar.col : ha(tar.col, .1),
                borderColor: isSold ? 'var(--sold-b)' : ha(tar.col, .52),
                color: isSold ? 'var(--muted2)' : tar.ct,
              }} onClick={() => !isSold && togSeat(sk, 0, `Rang ${rang} — Place ${i}`, tar.id)}>{i}</div>
            );
          }
          if (!seats.length) return null;
          return (
            <div key={rang} style={{ display: 'flex', alignItems: 'center', gap: 3, marginBottom: 4 }}>
              <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted)', width: 44, flexShrink: 0 }}>Rang {rang}</span>
              {seats}
            </div>
          );
        })}
        {gridSel.fosse === 'on' && (() => {
          const tar = tarifs[3];
          const isSold = sold['g_fosse'];
          return (
            <div className="cp-zone" style={{
              marginTop: 8, padding: 11, borderRadius: 10,
              background: ha(tar.col, isSold ? .03 : .07),
              border: `2px dashed ${ha(tar.col, isSold ? .16 : .38)}`,
              pointerEvents: isSold ? 'none' : 'auto', textAlign: 'center',
            }} onClick={() => !isSold && togSeat('g_fosse', 0, 'Zone Debout', tar.id)}>
              <div style={{ fontWeight: 800, color: isSold ? 'var(--muted)' : tar.ct }}>🕺 Zone Debout</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>{isSold ? 'Complet' : 'Disponible'}</div>
            </div>
          );
        })()}
      </div>
    );
  }

  // Drag-based plan
  if (elems.length === 0) {
    return (
      <div className="cplan" style={{ textAlign: 'center', padding: 36, color: 'var(--muted)' }}>
        <div style={{ fontSize: 34, marginBottom: 9 }}>🎭</div>
        Configurez votre salle, puis cliquez sur "Publier".
      </div>
    );
  }
  let mx = 720, my = 500;
  elems.forEach((e) => { mx = Math.max(mx, e.x + e.w + 22); my = Math.max(my, e.y + e.h + 22); });

  return (
    <div className="cplan">
      <div style={{ position: 'relative', width: mx, height: my }}>
        {elems.map((em) => {
          const tar = tarifs.find((t) => t.id === em.tid);
          const c = tar ? tar.col : brand;
          const ct = tar ? tar.ct : bTxt;
          const baseStyle = { position: 'absolute', left: em.x, top: em.y, width: em.w, height: em.h };

          if (em.type === 'scene') {
            return <div key={em.id} className="cp-scene" style={{ ...baseStyle, background: ha(brand, .07), border: `2px solid ${ha(brand, .38)}`, color: bTxt }}>{em.lbl}</div>;
          }
          if (em.type === 'bar' || em.type === 'wc') {
            return <div key={em.id} style={{ ...baseStyle, background: 'var(--surface2)', border: '1.5px solid var(--border)', color: 'var(--muted)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600 }}>{em.lbl}</div>;
          }
          if (em.type === 'entree') {
            return <div key={em.id} style={{ ...baseStyle, background: ha(brand, .07), borderTop: `3px solid ${brand}`, color: bTxt, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800 }}>{em.lbl}</div>;
          }
          if (em.type === 'lbl') {
            return <div key={em.id} style={{ ...baseStyle, color: 'var(--muted)', fontSize: 12, fontWeight: 700, display: 'flex', alignItems: 'center' }}>{em.lbl}</div>;
          }
          if (em.type === 'rang') {
            const n = Math.min(em.s, 20);
            return (
              <div key={em.id} style={{ ...baseStyle, display: 'flex', alignItems: 'center', gap: 3, padding: '3px 6px', borderRadius: 7, background: ha(c, .04), border: `1.5px solid ${ha(c, .2)}` }}>
                <span style={{ fontSize: 9, fontWeight: 700, color: ct, marginRight: 2, flexShrink: 0 }}>{em.lbl}</span>
                {[...Array(n)].map((_, i) => {
                  const key = `${em.id}_${i}`;
                  const isSold = sold[key];
                  const inC = panier.some((p) => p.key === key);
                  return (
                    <div key={i} className={`cp-seat ${isSold ? 'sold' : ''}`} style={{
                      background: isSold ? '' : inC ? c : ha(c, .1),
                      borderColor: isSold ? 'var(--sold-b)' : ha(c, .52),
                      color: isSold ? 'var(--muted2)' : ct,
                    }} onClick={() => !isSold && togSeat(em.id, i, `${em.lbl} — Place ${i + 1}`, em.tid)}>{i + 1}</div>
                  );
                })}
              </div>
            );
          }
          if (em.type === 'fosse' || em.type === 'vip') {
            const sn = Object.keys(sold).filter((k) => k.startsWith(em.id + '_')).length;
            const inC = panier.filter((p) => p.eId === em.id).length;
            const av = Math.max(0, em.s - sn);
            const full = av === 0;
            return (
              <div key={em.id} className="cp-zone" style={{
                ...baseStyle, background: ha(c, full ? .03 : inC ? .15 : .07), border: `2px dashed ${ha(c, full ? .16 : .42)}`, pointerEvents: full ? 'none' : 'auto',
              }} onClick={() => !full && togZone(em.id, em.lbl, em.tid)}>
                <div style={{ fontSize: 12, fontWeight: 800, color: full ? 'var(--muted)' : ct }}>{em.lbl}</div>
                <div style={{ fontSize: 10, color: full ? 'var(--muted)' : ct, opacity: .8 }}>{av} places</div>
                {inC > 0 && <div style={{ fontSize: 9, background: c, color: ct, padding: '1px 7px', borderRadius: 7, marginTop: 3 }}>✓ {inC}</div>}
              </div>
            );
          }
          if (em.type === 'tr' || em.type === 'tl') {
            const sn = Object.keys(sold).filter((k) => k.startsWith(em.id + '_')).length;
            const inC = panier.filter((p) => p.eId === em.id).length;
            const av = Math.max(0, em.s - sn - inC);
            const full = av === 0;
            return (
              <div key={em.id} className="cp-tbl" style={{
                ...baseStyle, borderRadius: em.type === 'tr' ? '50%' : 9,
                background: ha(c, full ? .04 : inC ? .15 : .1), border: `2px solid ${ha(c, full ? .17 : .48)}`,
                flexDirection: 'column', pointerEvents: full ? 'none' : 'auto',
              }} onClick={() => !full && togTbl(em.id, em.lbl, em.tid, em.s)}>
                <span style={{ fontSize: 11, fontWeight: 800, color: full ? 'var(--muted)' : ct }}>{em.lbl}</span>
                <span style={{ fontSize: 9, color: full ? 'var(--muted2)' : ct, opacity: .8 }}>{av}/{em.s}</span>
                {inC > 0 && <span style={{ fontSize: 9, background: c, color: ct, padding: '1px 5px', borderRadius: 6, marginTop: 2 }}>✓{inC}</span>}
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
